import React from 'react'

import ContactContainer from 'src/containers/Auth/Contact'

const ContactPage: React.FC = () => {
  return <ContactContainer />
}

export const PATH = '/contact' as const
export default ContactPage
